// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"37a38eab6371f963cae5","303":"e584568f276cd0b41071","495":"14a30e3fb151b2924d1d"}[chunkId] + ".js";
};